import axios from 'axios';

const instance = axios.create();

function ajax(opts) {
  const /* url = opts.url, */
    params = {
      _t_: new Date().getTime(),
      ...opts.params,
    };
  const type = opts.method;

  let cancel;
  const config = {
    baseURL: opts.baseURL,
    url: opts.url,
    method: type || 'post',
    cancelToken: new axios.CancelToken((c) => {
      cancel = c;
    }),
  };

  if (type === 'get') {
    config.params = params;
  } else if (type === 'put' || type === 'patch' || type === 'delete') {
    config.data = params;
  } else {
    config.data = params;
  }

  const xhr = instance(config);
  xhr.cancel = cancel;

  return xhr;
}

function setHeader(key, val) {
  // instance.defaults.headers.common['x3-Authentication'] = token
  instance.defaults.headers.common[key] = val;
}

// 判断请求是否被取消
// 传入axios请求的响应，用于判断该请求是否是被取消了
function isCancel(response) {
  return axios.isCancel(response);
}

export default {
  setHeader,
  instance,
  ajax,
  isCancel,
};
